module.exports = {
  ARCHIVE: "/archive",
  ROOT: "/",
  RSS: "/feed.xml",
  SEARCH: "/search",
}
